<h2 mat-dialog-title>Editar link de entrega</h2>
<mat-dialog-content>
  <div class="row">
    <div class="col-8">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Rut</mat-label>
        <input matInput [(ngModel)]="form.rut" />
      </mat-form-field>
    </div>
    <div class="col-4 d-flex align-items-center">
      <mat-checkbox [(ngModel)]="form.esExtranjero">Es extranjero</mat-checkbox>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Tipo de movimiento</mat-label>
        <mat-select [(ngModel)]="form.tipoMovimiento">
          <mat-option *ngFor="let tipo of tiposMovimiento" [value]="tipo">{{ tipo }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Buscar/cambiar equipo</mat-label>
        <input matInput [(ngModel)]="textoBusquedaEquipo" (input)="onBuscarEquipo($event)"
               placeholder="Buscar por modelo o número de serie" />
      </mat-form-field>
      <div *ngIf="equiposEncontrados.length > 0" class="list-group">
        <button type="button" class="list-group-item list-group-item-action" *ngFor="let eq of equiposEncontrados"
                (click)="seleccionarEquipo(eq)">
          {{ eq.tipo }} - {{ eq.marca }} {{ eq.modelo }} (S/N: {{ eq.numeroSerie }})
        </button>
      </div>
      <div *ngIf="equipoActual" class="text-muted mt-1">
        Equipo actual id: {{ equipoActual.id }}
      </div>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Observación</mat-label>
        <input matInput [(ngModel)]="form.observacion" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" type="button" [disabled]="guardando" (click)="guardar()">Guardar</button>
</mat-dialog-actions>
